import { render, staticRenderFns } from "./LvBtn.vue?vue&type=template&id=49b79344"
import script from "./LvBtn.vue?vue&type=script&lang=js"
export * from "./LvBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports